/* eslint-disable quotes */

export const getJsonLdHome = ({ data }) => {
  const { description } = data
  const obj = {
    "@context": "https://schema.org",
    "@type": "Hotel",
    "name": "Portella Palma",
    "url": "https://portellapalma.com",
    "logo": "https://portellapalma.com/images/svg/logo--portella.svg",
    "image": "https://portellapalma.com/images/1.jpeg",
    ...description && { description },
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Calle de la Portella, 9",
      "addressLocality": "Palma de Mallorca",
      "addressRegion": "Illes Balears",
      "postalCode": "07001",
      "addressCountry": "ES"
    },
    "telephone": "+34-871-62-62-63",
    "email": "mailto:welcome@portellapalma.com",
    "priceRange": "€€",
    "sameAs": [
      "https://www.instagram.com/portellapalma/",
      "https://www.tripadvisor.com/Hotel_Review-g187463-d27148957-Reviews-Portella_Palma-Palma_de_Mallorca_Majorca_Balearic_Islands.html"
    ]
  }

  return JSON.stringify(obj)
}
